(function () {
    function initConditionsSlider() {
      if (typeof $ === "undefined" || typeof $.fn.slick === "undefined") {
        setTimeout(initConditionsSlider, 100);
        return;
      }
  
      const slider = $("#conditions-slider");
      if (!slider.length) return;
  
      function isMobile() {
        return window.innerWidth <= 768;
      }
  
      function enableSlider() {
        if (!slider.hasClass("slick-initialized")) {
          slider.slick({
            slidesToShow: 1.20,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            speed: 400,
            swipe: true,
            touchMove: true,
            adaptiveHeight: true,
            prevArrow: `
              <button id="conditions-slider-prev-btn" class="conditions-section__nav-button conditions-section__nav-button--prev">
                <img src="https://cdn.shopify.com/s/files/1/0744/5387/6901/files/CaretCircleRight.png?v=1766398874" alt="prev"/>
              </button>`,
  
            nextArrow: `
              <button id="conditions-slider-next-btn" class="conditions-section__nav-button conditions-section__nav-button--next">
                <img src="https://cdn.shopify.com/s/files/1/0744/5387/6901/files/CaretCircleRight_1.png?v=1766398873" alt="next"/>
              </button>`
          });
        }
      }
  
      function disableSlider() {
        if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
      }
  
      if (isMobile()) enableSlider();
      else disableSlider();
  
      window.addEventListener("resize", () => {
        if (isMobile()) enableSlider();
        else disableSlider();
      });
    }
  
    document.addEventListener("DOMContentLoaded", initConditionsSlider);
  })();
  